module.exports = __webpack_public_path__ + "img/quest_icon_0023_pets.1423df6b.png";